export const SALE_WARONG_COPIES = 'SALE_WARONG_COPIES';

export const SET_SALE_WARONG_COPIES = 'SET_SALE_WARONG_COPIES';


// WEBPACK FOOTER //
// ./src/views/ReportApp/store/types/types_sale.js